/* eslint-disable react/prop-types */
import React from "react";
import { Box, Container } from "@mui/material";
import { motion } from "framer-motion";
import CustomText from "../../customComponents/customText";
import { Colors } from "../../assets/colors";
import MainHeader from "../../customComponents/MainHeader.jsx";

function Information({ heading, description }) {
  return (
    <Box sx={styles.appBarStyle}>
      <MainHeader heading={heading} headerStyle={styles.headerText} />
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Box sx={styles.contentBox}>
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <CustomText
              desc={description}
              fontFamily="Inter"
              colorvalue={Colors.black}
              style={{ ...styles.getAiReadyTxt, whiteSpace: "pre-line" }}
              h5
              fontWeight={400}
            />
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}

export default Information;

const styles = {
  boxImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    width: "100%",
    marginTop: 3,
  },
  image: {},
  getAiReadyTxt: {
    paddingBottom: 4,
    marginTop: 3,
    lineHeight: 1.4,
    textAlign: "left",
    fontStyle: "initial",
    fontSize: {
      xs: "0.8rem",
      sm: "1rem",
      md: "1.1rem",
    },
  },
  headerText: {
    textAlign: "center",
    backgroundColor: Colors.white,
    lineHeight: 1.8,
    marginTop: 4,
    letterSpacing: "-0.01em",
    fontSize: {
      xs: "1.5rem",
      sm: "1.75rem",
      md: "3.7rem",
    },
    padding: {
      xs: "0 16px",
      sm: "0 24px",
      md: "0 32px",
    },
  },
  andaihubTxt: {
    textAlign: "center",
    backgroundColor: Colors.white,
    lineHeight: 1.5,
    marginTop: 4,
    letterSpacing: "-0.01em",
    fontStyle: "initial",
  },

  appBarStyle: {
    overflowX: "hidden", // Prevent horizontal scrolling
    boxSizing: "border-box",
    backgroundColor: Colors.themeColor,
  },

  containerStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    paddingTop: {
      xs: 3,
      sm: 4,
      md: 6,
    },
    paddingBottom: {
      xs: 2,
      sm: 2.5,
      md: 3,
    },
  },

  contentBox: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    padding: {
      xs: "0 16px",
      sm: "0 24px",
      md: "0 32px",
    },
  },
};
